const isProduction = process.env.NODE_ENV === "production";

const logger = {
    info: (message, ...args) => {
        if (!isProduction) {
            console.info(`[INFO] ${message}`, ...args);
        }
    },
    warn: (message, ...args) => {
        if (!isProduction) {
            console.warn(`[WARN] ${message}`, ...args);
        }
    },
    error: (message, ...args) => {
        // We might want to log errors even in production, or send them to an error reporting service
        console.error(`[ERROR] ${message}`, ...args);
    },
    debug: (message, ...args) => {
        if (!isProduction) {
            console.debug(`[DEBUG] ${message}`, ...args);
        }
    },
};

export default logger;
